"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _types = require("../../types");
var usePagination = function usePagination(props) {
  var activePage = props.activePage,
    totalPages = props.totalPages,
    visiblePages = props.visiblePages,
    _a = props.showPreviousPageButton,
    showPreviousPageButton = _a === void 0 ? true : _a,
    _b = props.showFirstPageButton,
    showFirstPageButton = _b === void 0 ? true : _b,
    _c = props.showSeparationIndicator,
    showSeparationIndicator = _c === void 0 ? true : _c,
    _d = props.showLastPageButton,
    showLastPageButton = _d === void 0 ? true : _d,
    _e = props.showNextPageButton,
    showNextPageButton = _e === void 0 ? true : _e;
  var activePageMargin = (visiblePages - 1) / 2;
  // If the activePageMargin will end in a decimal number its better to show more upcoming pages (end) then old pages (start) that the user has
  // potentially already seen
  var start = activePage - Math.floor(activePageMargin);
  var end = activePage + Math.ceil(activePageMargin);
  var addFirstPageButton = false;
  var addFirstPageSeparationIndicator = false;
  var addLastPageSeparationIndicator = false;
  var addLastPageButton = false;
  // Shift towards the end if overhanging to the start
  if (start < 1) {
    end += 1 - start;
    start = 1;
  }
  // Shift towards the start if overhanging to the end but dont overhand to the start again
  if (end > totalPages) {
    start = Math.max(1, start - (end - totalPages));
    end = totalPages;
  }
  // Separate first page button and add separator
  if (showFirstPageButton && start > 1) {
    addFirstPageButton = true;
    start += 1;
    addFirstPageSeparationIndicator = showSeparationIndicator && start > 2;
  }
  // Separate last page button and add separator
  if (showLastPageButton && end < totalPages) {
    addLastPageButton = true;
    end -= 1;
    addLastPageSeparationIndicator = showSeparationIndicator && end < totalPages - 1;
  }
  var blueprint = [];
  if (showPreviousPageButton) {
    blueprint.push({
      type: _types.PaginationElementTypes.PreviousPageButton,
      disabled: activePage === 1
    });
  }
  if (addFirstPageButton) {
    blueprint.push({
      type: _types.PaginationElementTypes.PageButton,
      page: 1
    });
  }
  if (addFirstPageSeparationIndicator) {
    blueprint.push({
      type: _types.PaginationElementTypes.SeparationIndicator
    });
  }
  var pages = Array.from({
    length: end - start + 1
  }, function (_, i) {
    return i + start;
  });
  blueprint.push.apply(blueprint, pages.map(function (page) {
    return {
      type: _types.PaginationElementTypes.PageButton,
      page: page,
      active: page === activePage
    };
  }));
  if (addLastPageSeparationIndicator) {
    blueprint.push({
      type: _types.PaginationElementTypes.SeparationIndicator
    });
  }
  if (addLastPageButton) {
    blueprint.push({
      type: _types.PaginationElementTypes.PageButton,
      page: totalPages
    });
  }
  if (showNextPageButton) {
    blueprint.push({
      type: _types.PaginationElementTypes.NextPageButton,
      disabled: activePage === totalPages
    });
  }
  return blueprint;
};
var _default = usePagination;
exports.default = _default;